import isNumber from 'lodash/isNumber';
import { log } from './log';
import { TFunction } from 'i18next';
import { Extras } from '@sentry/types/types/extra';

export function dateFormatToISO(date: string) {
    const regex = /^(\d{1,2}).(\d{1,2}).(\d{2,4})$/.exec(date);

    if (regex !== null) {
        let day: number | string = parseInt(regex[1]);
        let month: number | string = parseInt(regex[2]);
        let year: number | string = parseInt(regex[3]);

        if (day > 0 && day <= 31 && month > 0 && month <= 12) {
            const minus = '-';

            if (year < 100) {
                year = `20${year}`;
            } else if (year < 1000) {
                year = `2${year}`;
            }

            if (day < 10) {
                day = `0${day}`;
            }

            if (month < 10) {
                month = `0${month}`;
            }

            return year + minus + month + minus + day;
        }
    }

    log.error('date is invalid', date as unknown as Extras);
    return '';
}

export function dateFormatToUTCMillis(date: string) {
    const isoDate = dateFormatToISO(date);

    if (isoDate === '') {
        log.error('date is invalid', date as unknown as Extras);
        return undefined;
    }

    const year = parseInt(isoDate.slice(0, 4));
    const month = parseInt(isoDate.slice(5, 7));
    const day = parseInt(isoDate.slice(8, 10));

    return Date.UTC(year, month - 1, day);
}

export function dateFormatToMonthYear(dateInMs: number, t: TFunction) {
    if (!isNumber(dateInMs)) {
        return null;
    }
    const date = new Date(dateInMs);
    return t('dateFormat.monthAndYear', {
        val: date
    });
}
